import { navigate } from 'gatsby';
import React from 'react';
import { linkStyles } from '../Link';

const ClearAll = function ({ children, onClick }: React.HTMLAttributes<HTMLButtonElement>) {
  const clearAllClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (onClick) {
      onClick(event);
    }
    navigate(window.location.pathname);
  };

  return (
    <button
      type="button"
      className={linkStyles({
        className:
          'pds-color-surface-text pds-font-weight-bold pds-m-0 pds-cursor-pointer pds-underline',
      })}
      onClick={clearAllClick}
    >
      {children}
    </button>
  );
};

export default ClearAll;
